<template>
  <el-dialog
    title="添加人员"
    :visible="true"
    width="600px"
    :close-on-click-modal="false"
    :before-close="() => $emit('remove')"
  >
    <el-form
      ref="form"
      :model="form"
      label-width="7rem"
      label-suffix=" : "
      :rules="rules"
    >
      <el-form-item v-for="(item, k) of form" :key="k" v-bind="formItemMap[k]">
        <el-input
          v-model="form[k]"
          :placeholder="'请输入' + formItemMap[k].label"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="$emit('remove')">取 消</el-button>
      <el-button type="primary" @click="confirm" :loading="loading">
        确 定
      </el-button>
    </span>
  </el-dialog>
</template>
<script>
import { activityPerson } from '@/api/ajax';
import { checkoutPhone } from '@/methods/unqualified';
import { moneyComplete } from '@/tools/money';

export default {
  name: 'active-person-upload',
  props: ['serviceActivityId'],
  data() {
    return {
      form: {
        // userName: '',
        // phone: '',
        // taskPrice: '',
        // enterpriseName: ''
      },
      formItemMap: {
        userName: {
          label: '姓名',
          prop: 'userName'
        },
        enterpriseName: {
          label: '个体名称',
          prop: 'enterpriseName'
        },
        phone: {
          label: '手机号',
          prop: 'phone'
        },
        taskPrice: {
          label: '结算金额',
          prop: 'taskPrice'
        }
      },
      loading: false,
      rules: {
        phone: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入手机号'));
              }
              if (!/^\d{11}$/g.test(value)) {
                callback(new Error('请输入有效的手机号'));
              } else {
                callback();
              }
            }
          },
          {
            validator: checkoutPhone,
            trigger: 'blur'
          }
        ],
        taskPrice: [
          {
            validator: (rule, value, callback) => {
              // 双方共同上传可不填
              if (+this.homeProject.fileUpSource === 3) {
                if (!value) {
                  //可以不填
                  return callback();
                }
                if (value && !/^\d+(\.\d+)?$/g.test(value)) {
                  callback(new Error('请输入数字值'));
                } else {
                  if (+value > 90000) {
                    callback(new Error('结算金额不能超过 90000'));
                  } else {
                    callback();
                  }
                }
              } else {
                //活动形式
                if (!value) {
                  return callback(new Error('请输入结算金额'));
                }
                if (!/^\d+(\.\d+)?$/g.test(value)) {
                  callback(new Error('请输入数字值'));
                } else {
                  if (+value > 90000) {
                    callback(new Error('结算金额不能超过 90000'));
                  } else if (+value <= 0) {
                    callback(new Error('结算金额必须大于 0'));
                  } else {
                    callback();
                  }
                }
              }
            }
          }
        ],
        userName: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                return callback(new Error('请输入姓名'));
              }
              if (!/^[\u4E00-\u9FA5]+(·[\u4e00-\u9fa5]+)*$/g.test(value)) {
                callback(new Error('请输入中文'));
              } else {
                callback();
              }
            }
          }
        ]
      }
    };
  },
  watch: {
    'form.userName': function(n, o) {
      setTimeout(() => {
        this.form.userName = this.form.userName.replace('.', '·');
      });
    },
    'form.phone': function(n, o) {
      setTimeout(() => {
        this.form.phone = this.form.phone.slice(0, 11);
      });
    },
    'form.taskPrice': function(n, o) {
      setTimeout(() => {
        this.form.taskPrice = this.form.taskPrice.replace(/(?<=\.\d{2})./g, '');
      });
    }
  },
  computed: {
    submitQuery() {
      const { taskPrice } = this.form;
      let rawData = {
        ...this.form,
        serviceActivityId: this.serviceActivityId
      };
      const query = {
        ...rawData,
        // 此三目运算符是为了【双方共同上传】时结算金额可不填，走moneyComplete方法会NaN
        taskPrice: isNaN(moneyComplete(taskPrice))
          ? ''
          : moneyComplete(taskPrice)
      };

      return query;
    },
    homeProject() {
      return this.$store.state.homeProject;
    }
  },
  methods: {
    async confirm() {
      // 本地验证表单内容
      try {
        await this.$refs.form.validate();
      } catch (e) {
        console.error(e);
        return;
      }
      // 远程提交
      this.loading = true;
      try {
        await activityPerson.add(this.submitQuery);
        this.$emit('confirm');
        this.$emit('remove');
      } catch (e) {
        console.error('error: activityPerson.add', e);
      }
      this.loading = false;
    }
  },
  created() {
    // 获得 项目类型
    const { userEnterpriseType } = this.$store.state.homeProject;
    // 需要 展示的字段
    let formItems = [];
    switch (+userEnterpriseType) {
      case 0: //普通
        formItems = ['userName', 'phone', 'taskPrice'];
        break;
      case 1: // 普通，0是个啥？没有0
        formItems = ['userName', 'phone', 'taskPrice'];
        break;
      case 2: //个体
        formItems = ['userName', 'enterpriseName', 'phone', 'taskPrice'];
        break;
      case 3: //园区个体
        formItems = ['phone', 'taskPrice'];
        break;
      default:
        throw new Error('获取项目类型错误');
    }
    // 初始化 vm form 数据
    let formData = formItems.reduce((obj, key) => {
      obj[key] = '';
      return obj;
    }, {});

    Object.keys(formData).forEach(k => {
      this.$set(this.form, k, '');
    });
  }
};
</script>

<style scoped>
.upload-demo {
  width: 100%;
}

/deep/ .el-upload {
  width: 100%;
}
</style>
